import React from 'react';
import * as core from 'cw-ui-core';
import getDialog from './DialogFactory';
import AppContainer from 'src/components/App/AppContainer';

export const MODULE_ID = 'partner-portal-shell';

const getHomeRedirectPath = () => {
  const pathRedirectMap = new Map();
  pathRedirectMap.set("/", "/");
  pathRedirectMap.set("/unite", "/unite");
  pathRedirectMap.set("/unite/pricing", "/unite");
  pathRedirectMap.set("/identify", "/identify");
  pathRedirectMap.set("/identify/pricing", "/identify");
  pathRedirectMap.set("/settings", "/sso/users");
  pathRedirectMap.set("/settings/applications", "/sso/products");
  pathRedirectMap.set("/settings/registrationtoken", "/sso/products/registrationToken");
  pathRedirectMap.set("/settings/products", "/sso/products");
  pathRedirectMap.set("/settings/importedusers", "/sso/importedusers");
  pathRedirectMap.set("/settings/authentication", "/sso/authentication");
  pathRedirectMap.set("/settings/roles", "/sso/roles");
  pathRedirectMap.set("/settings/support", "/sso/support");
  pathRedirectMap.set("/settings/users", "/sso/users");
  pathRedirectMap.set("/settings/invites", "/sso/importedusers");
  pathRedirectMap.set("/university", "/university");
  pathRedirectMap.set("/addlicenses", "/addlicenses");
  return pathRedirectMap.get(window.location.pathname.toLowerCase());
};

const redirectToHome = (homeUrl, path) => {
  window.location.assign(homeUrl + path + window.location.search);
};

const onBeforeAppLoad = configJson => {
  const homeRedirectPath = getHomeRedirectPath();
  if (window.location.search.includes('referral')) {
    window.location.assign(configJson.partnerPortalUrl + window.location.pathname + window.location.search);
  }
  else if (configJson.enableHomeRedirects && homeRedirectPath) {
    redirectToHome(configJson.homeUrl, homeRedirectPath);
  }
  else {
    const oidcUserManagerConfig = {
      client_id: 'partnerportal',
      redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/signin-oidc`,
      response_type: 'token id_token',
      scope: 'openid profile email api.centralservices api.billing roles api.partners api.users api.products.readonly api.productinstances api.sts.admin',
      authority: configJson.authority,
      automaticSilentRenew: false,
      post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`
    };
    core.initializeOidc(oidcUserManagerConfig);
  }
};

const getScreenComponent = () => {
  if (window.location.search.includes('referral')) {
    return <div>Redirecting...</div>;
  }
  else {
    return <AppContainer />;
  }
};

const config = {
  includeOidc: true,
  onBeforeAppLoad,
  screenComponent: getScreenComponent(),
  getDialog,
  includeMobileLayout: true
};

// set default theme
core.setTheme('#0067B1');

core.appEntryPoint(MODULE_ID, config);


// WEBPACK FOOTER //
// ./src/index.js